import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomReuseStrategy extends BaseComponent implements RouteReuseStrategy {
    public static resetRoutes = false;
    storedRouteHandles = new Map<string, DetachedRouteHandle>();

    // Decides if the route should be stored
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        let detach = true;
        if (!this.env.routeReuseDefault) {
            detach = false;
        }
        if (route.data.reuse === false) {
            detach = false;
        }
        // this.log.info(`shouldDetach ${detach}`, route);
        return detach;
    }

    // Store the information for the route we're destructing
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        this.storedRouteHandles.set(this.getRouteID(route), handle);
    }

    // Return true if we have a stored route object for the next route
    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        if (CustomReuseStrategy.resetRoutes) {
            this.log.info('Clearning stored routes');
            this.storedRouteHandles.clear();
            CustomReuseStrategy.resetRoutes = false;
        }
        const attach = this.storedRouteHandles.has(this.getRouteID(route));

        // this.log.info(`shouldAttach ${attach}`, route);

        return attach;
    }

    // If we returned true in shouldAttach(), now return the actual route data for restoration
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
        return this.storedRouteHandles.get(this.getRouteID(route));
    }

    // Reuse the route if we're going to and from the same route
    shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
        // const reuse = future.routeConfig === current.routeConfig;

        const reuse = this.getRouteID(future) === this.getRouteID(current);

        // this.log.info(`shouldReuseRoute ${reuse}`, future, current);

        return reuse;
    }

    getRouteID(route: ActivatedRouteSnapshot): string {
        let routeID = route.data.routeID;

        if (route.data.paramName) {
            routeID += route.params[route.data.paramName];
        }
        // this.log.data('getRouteID: ' + routeID);
        return routeID;
    }
}
